module.exports = __webpack_public_path__ + "img/sc-rewards.3e131c6a.png";